import axios from 'axios'
import Cookies from 'universal-cookie'

const cookies = new Cookies(null, { path: '/' })

const sendNXLOG = (data) => {
  const fields = {
    arena_page_url: window.location.href,
    arena_page_referrer: document.referrer,
    ...data,
  }

  axios.post(`/api/nxlog/no-auth/web`, fields, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}

sendNXLOG({ stage: '100' })

let numberOfCheckGaCookie = 0
const maxNumberOfCheckGaCookie = 5
const checkGaCookie = setInterval(function () {
  if (cookies.get('_ga')) {
    window.console.log('NXLOG _ga cookie found')
    clearInterval(checkGaCookie)
    sendNXLOG({
      stage: '101',
    })
  } else if (numberOfCheckGaCookie >= maxNumberOfCheckGaCookie) {
    window.console.log('NXLOG _ga cookie not found')
    clearInterval(checkGaCookie)
  }
  numberOfCheckGaCookie++
}, 1000)

// PARTNERKEY cookie setting for MSW
cookies.set('PARTNERKEY', '3266')
